<template>
  <v-container v-if="Object.keys(loadedSettings).length" fluid>
    <v-card outlined>
      <v-card-title>{{ $t('settings.permissions.cancellation') }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="loadedSettings.pickupOrderCancelRoles"
              :items="shopLevelRoles"
              :label="$t('settings.permissions.pickupOrderCancelRoles')"
              :messages="$t('settings.permissions.pickupOrderCancelRolesHelp')"
              :placeholder="$t('settings.permissions.noRoleSelected')"
              persistent-placeholder
              multiple
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="loadedSettings.ebookingCancelRoles"
              :items="shopLevelRoles"
              :label="$t('settings.permissions.ebookingCancelRoles')"
              :placeholder="$t('settings.permissions.noRoleSelected')"
              persistent-placeholder
              multiple
            />
          </v-col>
        </v-row>
        <p class="grey--text caption mt-4 mb-0">{{ $t('settings.permissions.cancellationExemptions') }}</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { shopLevelRoleOptions } from '@/helpers/pickupCancelPermission'

  export default {
    name: 'PermissionsSettings',
    props: {
      loadedSettings: {
        type: Object,
        required: true,
      },
    },
    computed: {
      shopLevelRoles() {
        return shopLevelRoleOptions((key) => this.$t(key))
      },
    },
  }
</script>
